export const FETCH_ORGANIZATION_DETAILS_REQUEST = 'FETCH_ORGANIZATION_DETAILS_REQUEST';
export const FETCH_ORGANIZATION_DETAILS_SUCCESS = 'FETCH_ORGANIZATION_DETAILS_SUCCESS';
export const FETCH_ORGANIZATION_DETAILS_FAILURE = 'FETCH_ORGANIZATION_DETAILS_FAILURE';
